/**
 * Conflict tooltip component for highlighting scheduling conflicts
 */

import React from 'react';
import { FiAlertTriangle, FiClock, FiMapPin, FiUser } from 'react-icons/fi';

const ConflictTooltip = ({ conflicts, isVisible, children }) => {
  if (!isVisible || !conflicts || conflicts.length === 0) {
    return children;
  }

  const getConflictIcon = (type) => {
    switch (type) {
      case 'clinician':
      case 'ooo':
        return <FiUser className="w-4 h-4" />;
      case 'room':
        return <FiMapPin className="w-4 h-4" />;
      case 'closure':
        return <FiClock className="w-4 h-4" />;
      default:
        return <FiAlertTriangle className="w-4 h-4" />;
    }
  };

  const getConflictColor = (type) => {
    switch (type) {
      case 'clinician':
      case 'ooo':
        return 'text-amber-600';
      case 'room':
        return 'text-orange-600';
      case 'closure':
        return 'text-red-600';
      default:
        return 'text-amber-600';
    }
  };

  return (
    <div className="relative group">
      {children}
      
      {/* Tooltip */}
      <div className="absolute z-50 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-200 bottom-full left-1/2 transform -translate-x-1/2 mb-2">
        <div className="bg-gray-900 text-white text-sm rounded-lg py-2 px-3 max-w-xs shadow-lg">
          <div className="flex items-center mb-2">
            <FiAlertTriangle className="w-4 h-4 text-amber-400 mr-2" />
            <span className="font-medium">Scheduling Conflicts</span>
          </div>
          
          <div className="space-y-1">
            {conflicts.map((conflict, index) => (
              <div key={index} className="flex items-start space-x-2">
                <div className={`mt-0.5 ${getConflictColor(conflict.type)}`}>
                  {getConflictIcon(conflict.type)}
                </div>
                <div className="text-xs leading-relaxed">
                  {conflict.message}
                </div>
              </div>
            ))}
          </div>
          
          {/* Arrow */}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2">
            <div className="border-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConflictTooltip;
